module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/fontawesome-webfont.woff
// module id = ./node_modules/@ps/common-core/dist/fonts/fontawesome-webfont.woff
// module chunks = 1